// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-Xx8","formField":"sqfVa","captcha":"_22kJu","StepButton":"_1WyGq","AlreadyLogin":"_3-1un","confirmationLinkSent":"_1qdIa","termsCheckbox":"PN_b_"};